export { default as CellsSolidIcon } from './CellsSolidIcon';
